import React from "react";

import ReviewContent from "./review-content";
import ReviewProfile from "./review-profile";
import ReviewPhotoOnly from "./review-photo-only";
import ReviewPhoto from "./review-photo";
import PropTypes from "prop-types";
import { idPropType, productPropType } from "components/propTypes";

class Review extends React.Component {
  static propTypes = {
    newAPIData: PropTypes.bool,
    filters: PropTypes.object,
    firstPhotoId: idPropType,
    product: productPropType,
    renderReviewsPhotoOnly: PropTypes.bool,
    review: PropTypes.object,
    sort: PropTypes.string,
    submitComment: PropTypes.func,
    userType: PropTypes.object,
    isUserSpecificReview: PropTypes.bool,
  };

  static defaultProps = {
    renderReviewsPhotoOnly: false,
    isUserSpecificReview: false,
  };

  shouldRenderImage = () => {
    const newAPIData = this.props.newAPIData;
    return (
      (!newAPIData && !!(this.props.review.moment?.photos && this.props.review.moment.coverPhotoId)) ||
      (newAPIData && this.props.review?.photos && this.props.review?.coverPhotoId)
    );
  };

  reviewPhoto = () => {
    const newAPIData = this.props.newAPIData;
    if (!this.shouldRenderImage()) {
      return;
    }

    if (!newAPIData && this.props.renderReviewsPhotoOnly) {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <ReviewPhotoOnly {...this.props} />;
    }

    return (
      <ReviewPhoto
        coverPhotoId={newAPIData ? this.props.review.coverPhotoId : this.props.review.moment.coverPhotoId}
        photos={newAPIData ? this.props.review?.photos : this.props.review.moment.photos}
        reviewId={newAPIData ? this.props.review.reviewId : this.props.review.id}
      />
    );
  };

  render() {
    const newAPIData = this.props.newAPIData;
    const product = newAPIData ? this.props.product?.[this.props?.review?.styleName] : this.props.product;

    return (
      <div className="pdp-ind-review">
        <ReviewProfile
          filters={this.props?.filters}
          filterUserType={this.props.userType}
          moment={newAPIData ? this.props.review : this.props.review?.moment}
          reviewer={
            newAPIData
              ? { firstName: this.props.review?.firstName, ...this.props.review?.reviewerSnapshot }
              : this.props.review?.user
          }
          sort={this.props?.sort}
          isUserSpecificReview={this.props.isUserSpecificReview}
          product={product}
        />
        <ReviewContent
          moment={newAPIData ? this.props.review : this.props.review?.moment}
          submitComment={this.props?.submitComment}
          product={product}
          isUserSpecificReview={this.props.isUserSpecificReview}
        />
        {this.reviewPhoto()}
      </div>
    );
  }
}

// duplicate logic from storefront ruby...
// couldn't find a nice clean place to modify the ajax response.
// /ourrunway/moment/#{ URI.encode moment.item.designer.name }-#{ URI.encode moment.item.display_name }--id-#{ moment.cover_photo.id }
Review.canonicalUrl = function (review, product, newAPIData) {
  return [
    "/ourrunway/moment/",
    encodeURIComponent(newAPIData ? product?.designerDisplayName : product?.designer?.displayName),
    "-",
    encodeURIComponent(product?.displayName),
    "--id-",
    newAPIData ? review?.coverPhotoId : review?.moment?.coverPhotoId,
  ].join("");
};

export default Review;

export const { canonicalUrl } = Review;
